const isMac = (
  navigator: Pick<Navigator, 'platform'> = window.navigator
): boolean => navigator.platform.toUpperCase().indexOf('MAC') >= 0

export default isMac
